"use client";

import { ANALYTICS_CONSENT_SETTINGS_EVENT } from "@/lib/analytics-consent";

export function AnalyticsConsentSettingsButton() {
  return (
    <button
      type="button"
      onClick={() => {
        window.dispatchEvent(
          new CustomEvent(ANALYTICS_CONSENT_SETTINGS_EVENT),
        );
      }}
      className="inline-flex min-h-[44px] items-center border-0 bg-transparent p-0 text-[13px] text-text-muted transition-colors hover:text-teal-dark"
    >
      Cookie settings
    </button>
  );
}
